import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login } from '../store/authSlice';

const StepBar = ({ step, steps, setStep }) => {
    return (
        <div className="step-bar">
            <div className="step-bar__steps">
                {Array.from({ length: steps }, (_, i) => (
                    <div
                        key={i}
                        onClick={() => step !== (i + 1) && setStep(i + 1)}
                        className={`step-bar__step ${ (i + 1) === step ? 'active' : ''}`}
                    >
                    </div>
                ))}
            </div>
        </div>
    );
}

const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const status = useSelector(state => state.auth.status);
    const authData = useSelector(state => state.auth.authData);
    const [step, setStep] = useState(1);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    // Se il login ha successo, vai alla main page
    useEffect(() => {
        if (status === 'succeeded' && authData) {
            navigate('/');
        }
    }, [status, authData, navigate]);

    const handleNext = () => setStep(2);
    const handleSubmit = e => {
        e.preventDefault();
        dispatch(login({ email, password }));
    };

    return (
        <div className="login">
            {step === 1 ? (
                <div className="login__page login__welcome_page">
                    <img
                        className="login__cover"
                        src="/images/welcome-cover.png"
                        alt="Benvenuto"
                    />
                    <StepBar step={step} steps={2} setStep={setStep} />
                    <div className="login__body">
                        <h1>Benvenuto!</h1>
                        <p>
                            Da qui potrai gestire tutte le chiamate del tuo ufficio senza
                            stress. Facile, veloce e tutto a portata di mano.
                        </p>
                        <button onClick={handleNext}>Avanti</button>
                    </div>
                </div>
            ) : (
                <div className="login__page login__login_page">
                    <img
                        className="login__cover"
                        src="/images/login-cover.png"
                        alt="Accedi"
                    />
                    <StepBar step={step} steps={2} setStep={setStep}/>
                    <div className="login__body">
                        <form className="login__form" onSubmit={handleSubmit}>
                            <label>Email</label>
                            <input
                                type="email"
                                placeholder="Inserisci la tua email"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                required
                            />
                            <label>Password</label>
                            <input
                                type="password"
                                placeholder="Inserisci la tua password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                required
                            />
                            <button type="submit" disabled={status === 'loading'}>
                                {status === 'loading' ? 'Caricamento...' : 'Accedi'}
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Login;
